<template>
  <el-dialog title="曲目编辑" :visible.sync="dialogVisible" width="500px">
    <el-form ref="form" :model="row" label-width="auto">
      <el-form-item label="曲目名称">
        <el-input v-model.trim="row.name" placeholder="请输入曲目名称"></el-input>
      </el-form-item>
      <el-form-item label="曲目伴奏">
        <el-input @clear="clear('accompaniment')" v-model="row.accompaniment_label" placeholder="请选择伴奏" @focus="focus('accompaniment')" clearable></el-input>
      </el-form-item>
      <el-form-item label="演奏视频">
        <el-input @clear="clear('play')" v-model="row.play_label" placeholder="请选择演奏视频" @focus="focus('play')" clearable></el-input>
      </el-form-item>
      <el-form-item label="俯拍视频">
        <el-input @clear="clear('overhead')" v-model="row.overhead_label" placeholder="请选择俯拍视频" @focus="focus('overhead')" clearable></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="loading">确 定</el-button>
    </span>
    <accompanimentTable ref="accompaniment" @confirm="confirm"></accompanimentTable>
    <playTable ref="play" @confirm="confirm"></playTable>
    <overheadTable ref="overhead" @confirm="confirm"></overheadTable>
  </el-dialog>
</template>

<script>
import accompanimentTable from "./accompaniment-table";
import playTable from "./play-table";
import overheadTable from "./overhead-table";
import {updateSong} from "@/api/music";

export default {
  name: "song-edit",
  components: {
    accompanimentTable,
    playTable,
    overheadTable
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      row: {
        accompaniment_label: undefined,
        play_label: undefined,
        overhead_label: undefined
      }
    };
  },
  methods: {
    clear(type) {
      switch (type) {
        case 'accompaniment':
          this.row = Object.assign(this.row, {
            accompaniment_label: undefined,
            music_accompaniment_id: 0,
          })
          break
        case 'play':
          this.row = Object.assign(this.row, {
            play_label: undefined,
            music_play_video_id: 0,
          })
          break
        case 'overhead':
          this.row = Object.assign(this.row, {
            overhead_label: undefined,
            music_overhead_video_id: 0,
          })
          break
      }
      this.$forceUpdate()
    },
    async submit() {
      let form = {
            id: this.row.id,
            name: this.row.name,
            music_accompaniment_id: this.row.music_accompaniment_id,
            music_play_video_id: this.row.music_play_video_id,
            music_overhead_video_id: this.row.music_overhead_video_id
          }
      ;
      this.loading = true;
      try {
        await updateSong(form);
        this.$emit("refresh");
        this.dialogVisible = false;
        this.$message.success("操作成功");
      } finally {
        this.loading = false;
      }
    },
    confirm(componentName, {id, label}) {
      if (componentName === "accompaniment") {
        this.row.music_accompaniment_id = id;
        this.row.accompaniment_label = label;
      } else if (componentName === "play") {
        this.row.music_play_video_id = id;
        this.row.play_label = label;
      } else {
        this.row.music_overhead_video_id = id;
        this.row.overhead_label = label;
      }
      this.$forceUpdate();
    },
    focus(componentName) {
      this.$refs[componentName].show();
    },
    show(row) {
      this.row = {...row};
      this.row.accompaniment_label = row.music_accompaniment_id ?
          row.music_accompaniment_id +
          (row.accompaniment ? row.accompaniment.name : "") : undefined;
      this.row.play_label = row.music_play_video_id ?
          row.music_play_video_id + (row.play ? row.play.name : "") : undefined;
      this.row.overhead_label = row.music_overhead_video_id ?
          row.music_overhead_video_id + (row.overhead ? row.overhead.name : "") : undefined;

      this.dialogVisible = true;
    }
  }
};
</script>

<style scoped>
</style>